export const REVIEW_TRAVEL_NERD_SLUGS = [
  'aadvantage-aviator-red',
  'aer-lingus-visa',
  'aeroplan-credit-card',
  'alaska-airlines-credit-card',
  'allegiant',
  'amazon-prime-rewards',
  'american-express-gold-delta-skymiles',
  'american-express-green',
  'american-express-platinum',
  'american-express-platinum-delta-skymiles',
  'american-express-premier-rewards-gold',
  'atmos-rewards-summit',
  'bank-of-america-travel-rewards',
  'barclaycard-miles-and-more',
  'best-western-premium',
  'best-western-rewards',
  'bilt-blue-card',
  'bilt-credit-card',
  'bilt-obsidian',
  'bilt-palladium',
  'blue-delta-skymiles',
  'british-airways-card',
  'capital-one-savorone-student',
  'capital-one-venture',
  'capital-one-venture-x',
  'capital-one-ventureone',
  'chase-freedom-flex',
  'chase-freedom-unlimited',
  'chase-sapphire-preferred',
  'chase-sapphire-reserve',
  'choice-privileges-card',
  'choice-privileges-select-card',
  'citi-aadvantage-executive',
  'citi-aadvantage-globe',
  'citi-aadvantage-mileup',
  'citi-aadvantage-platinum',
  'citi-custom-cash',
  'citi-double-cash',
  'citi-prestige',
  'citi-strata',
  'citi-strata-premier',
  'citi-strata-elite',
  'delta-reserve',
  'discover-it-miles',
  'disney-inspire-visa',
  'disney-premier-visa',
  'disney-visa',
  'free-spirit-travel-more',
  'frontier-airlines-card',
  'hilton-amex-ascend',
  'hilton-amex-review',
  'hilton-honors-aspire',
  'hotels-com-rewards',
  'iberia-visa',
  'ihg-credit-card',
  'ihg-traveler',
  'jetblue-card',
  'jetblue-plus',
  'jetblue-premier',
  'marriott-bonvoy-bevy',
  'marriott-bonvoy-bold',
  'marriott-bonvoy-boundless',
  'marriott-bonvoy-bountiful',
  'marriott-bonvoy-brilliant',
  'marriott-rewards',
  'one-key',
  'one-key-plus',
  'orbitz-rewards',
  'princess-cruises-rewards',
  'radisson-rewards-platinum',
  'radisson-rewards-premier',
  'skypass-secured',
  'southwest-rapid-rewards-plus',
  'southwest-rapid-rewards-premier',
  'southwest-rapid-rewards-priority',
  'uber-card',
  'united-club',
  'united-explorer',
  'united-gateway',
  'united-quest',
  'united-travelbank',
  'us-bank-altitude-connect',
  'us-bank-altitude-go',
  'virgin-atlantic',
  'wells-fargo-active-cash',
  'wells-fargo-autograph',
  'wells-fargo-autograph-journey',
  'wells-fargo-propel',
  'world-of-hyatt',
  'wyndham-rewards-visa',
  'wyndham-rewards-visa-annual-fee',
];
